import {useInterval} from '$app/utils/util';
import React, {useState} from 'react';
import moment from 'moment';
import { ReminderCard } from './styled';

const reminderDefault = {
  reminderId: null,
  ownerId: '',
  ownerType: '',
  dueDateTime: '',
  description: '',
  completedAt: '',
  createdAt: '',
  createdBy: '',
}

export function Reminder({reminder = reminderDefault }) {
  let [count, setCount] = useState(0);
  useInterval(() => setCount(count + 1), 10000);
  const remainingTime = moment(reminder.dueDateTime).fromNow(true);
  const isDueNow = moment(reminder.dueDateTime).isBefore(now);
  const now = moment().format();
  if(isDueNow) {
    return (
      <ReminderCard
        key={`${reminder.reminderId}_${count}`}
        style={{
          color: '#ff5858',
          border: '1px solid #d64040',
        }}
      >
        <div style = {{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: "center",
        }}>
          <div style={{ fontSize: 21, fontWeight: 'bold', color: '#ff5858' }}>
            Reminder
          </div>
          <div>
            <span style={{ color: '#201e1e', fontSize: 14 }}>Quoted - Call Due </span><b style={{ fontSize: 21 }}>{remainingTime} ago</b>
          </div>
        </div>
      </ReminderCard>
    );
  }
  return (
    <ReminderCard
      key={`${reminder.reminderId}_${count}`}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: "center" }}>
        <div style={{ fontSize: 21, fontWeight: 'bold', color: '#111' }}>
          Reminder
        </div>
        <div>
        <span style={{ color: '#201e1e', fontSize: 14 }}>Quoted - Call Due in</span> <b style={{ fontSize: 21, color: '#00b67a' }}>{remainingTime}</b>
        </div>
      </div>
    </ReminderCard>
  );
}

export default function ReminderList({ reminders = [] }) {
  return <>{reminders.map(reminder => <Reminder reminder={reminder} />)}</>;
}
